import { h } from 'preact';
import styled from 'styled-components';
import { getImageSrc } from '@authentic/loyalty-pwa/util';

interface CTAWidgetProps {
  url: string;
}

const Wrapper = styled.div`
  display: flex;
  height: 222px;
  background-color: white;
  justify-content: center;
  align-items: center;
  padding: 0 24px;
`;

const CTALogo = styled.img`
  width: 82px;
  height: 101.84px;
  margin-right: 24px;
`;

const TextWrapper = styled.div``;

const Label = styled.div<{ size: number; bold: boolean; }>`
  font-family: Nunito Sans;
  font-style: normal;
  font-weight: ${(props) => (props.bold ? 'bold' : 'normal')};
  font-size: ${(props) => props.size}px;
  line-height: 22px;
  color: #000000;
`;

const Link = styled.a`
  font-family: Nunito Sans;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 18px;
  color: #000000;
`;

export const CTAWidget = ({ url }: CTAWidgetProps) => {
  return (
    <Wrapper>
      <CTALogo src={getImageSrc(require('../assets/icons/cta-logo.png').default)} alt="" />
      <TextWrapper>
        <Label size={18} bold={true}>
          Ordering in person at a Del Taco location?
        </Label>
        <Label size={16} bold={false}>
          Go to the SCAN page to use Redeemed Rewards.
        </Label>
        <Link href={url}>Go to Scan page</Link>
      </TextWrapper>
    </Wrapper>
  );
};
